import { Col, Row } from "antd";
import { Content, Footer } from "antd/lib/layout/layout";
import { Switch, useLocation } from "react-router-dom";

import MenuItems from "./menuItems/menu.Items";
import { FooterComponent } from "./pages/footer/footer.component";

function Docs({ children }) {
  const { pathname } = useLocation();

  pathname.includes("docs") && import("./assets/styles/docs.css");

  return (
    <div className="App">
      <Row>
        <Col>
          <MenuItems />
        </Col>
        <Col>
          <Switch>
            <Content>{children}</Content>
          </Switch>
        </Col>
      </Row>
      <Footer className="footer-content">
        <FooterComponent />
      </Footer>
    </div>
  );
}

export default Docs;
